import { render, staticRenderFns } from "./dicDrawer.vue?vue&type=template&id=203dc76c&scoped=true&"
import script from "./dicDrawer.vue?vue&type=script&lang=js&"
export * from "./dicDrawer.vue?vue&type=script&lang=js&"
import style0 from "./dicDrawer.vue?vue&type=style&index=0&id=203dc76c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203dc76c",
  null
  
)

export default component.exports